import React from "react";
import PropTypes from "prop-types";
import Hint, { TYPES } from "components/atoms/Hint";
import InputSearch from "components/molecules/InputSearch";

const HintKeywordSearch = (props) => {
  const { type, text, inputSearch, onFilterChange } = props;

  return (
    <Hint type={type}>
      <p>{text}</p>
      <InputSearch
        {...inputSearch}
        onSearch={(value) => onFilterChange(inputSearch.name, value)}
      />
    </Hint>
  );
};

HintKeywordSearch.propTypes = {
  type: PropTypes.oneOf(TYPES).isRequired,
  text: PropTypes.string.isRequired,
  inputSearch: PropTypes.shape({
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    onMountStateChange: PropTypes.func.isRequired,
    value: PropTypes.string,
  }).isRequired,
  onFilterChange: PropTypes.func.isRequired,
};

export default HintKeywordSearch;
